<template>
  <div class="inputWidth">
    <b-input-group>
      <b-form-select v-if="dataslot.property.allowedValues && dataslot.property.allowedValues.length > 0"
        v-model="value" :options="dataslot.property.allowedValues"  :id="dataslot.id" :name="dataslot.id" :class="highlight()"  v-on:change="handleBlur()" :state="inputState()">
      </b-form-select>

      <b-form-checkbox v-else-if="dataslot.property.type.__type=='Boolean'"
        :id="dataslot.id"
        :name="dataslot.id"
        v-model="value"
        v-on:change="switchCheckbox()"
        switch>
      </b-form-checkbox>

      <b-form-input v-else :id="dataslot.id" :name="dataslot.id" type="text" v-model="value" :class="highlight()" v-on:blur="handleBlur()" :state="inputState()">
      </b-form-input>

      <b-dropdown id="dropdown-right" right variant="light" v-if="dataslot && dataslot.candidateValues && dataslot.candidateValues.length > 1" class="ml-1">
        <b-dropdown-item href="#" v-for="v in dataslot.candidateValues" :key="v.value" @click="selectSuggestion(v.value)" >{{v.value}} <b-badge variant="light">Niveau {{v.confidence.level}}</b-badge></b-dropdown-item>
      </b-dropdown>

      <b-button variant="light" v-if="value && dataslot.property.type.__type!='Boolean'"><b-icon variant="danger" icon="backspace" @click="clearInput()"></b-icon></b-button>

      <b-button variant="light" v-if="showSave"><b-icon variant="danger" icon="cloud-upload" @click="saveSlot()"></b-icon></b-button>

    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'DataToCollect',
  props: ['dataslot'],
  data() {
    return {
      value: '',
      showSave: false
    };
  },
  computed: {
    dialogState () {
      return this.$store.state.dialogState;
    },
  },
  methods: {
    inputState() {
      if( this.value )
        return true;
      else if ( this.dataslot.property.mandatory )
        return false;

      return null;
    },
    highlight() {
      if(this.dialogState && this.dialogState.currentDialogueTurn && this.dialogState.currentDialogueTurn.modifiedSlots) {
        for ( var s in this.dialogState.currentDialogueTurn.modifiedSlots ) {
          if(this.dataslot.id == this.dialogState.currentDialogueTurn.modifiedSlots[s].id) {
            return 'highlight';
          }
        }
      }
      return '';
    },
    clearInput() {
      this.value = '';
      this.showSave = false;
    },
    handleBlur() {
      // set showSave
      if( this.value && this.dataslot &&  this.dataslot.userValue && this.value != this.dataslot.userValue.value ) {
        this.showSave = true;
      } else if ( this.dataslot && !this.dataslot.userValue && this.value) {
        this.showSave = true;
      } else {
        this.showSave = false;
      }
    },
    switchCheckbox() {
      this.showSave = true;
    },
    saveSlot() {
      this.showSave = false;
      this.$store.dispatch('saveSlot', { 'id': this.dataslot.id , 'value': this.value});
    },
    selectSuggestion(value) {
      this.value=value;
      this.handleBlur();
    }
  },
  created() {
    if( this.dataslot && this.dataslot.userValue )
      this.value = this.dataslot.userValue.value;
    else if (this.dataslot.candidateValues && this.dataslot.candidateValues[0])
      this.value = this.dataslot.candidateValues[0].value;
    else
      this.value = '';
  },
  watch: {
    dataslot: function(newVal) {
      // set value
      if( newVal && newVal.userValue )
        this.value = newVal.userValue.value;
      else if (newVal && newVal.candidateValues && newVal.candidateValues[0])
        this.value = newVal.candidateValues[0].value;
    }
  }
}
</script>

<style scoped>
  .inputWidth {
    width: 90%;
  }
</style>
